import { render } from "./cardComp.vue?vue&type=template&id=76120e76&scoped=true"
import script from "./cardComp.vue?vue&type=script&lang=js"
export * from "./cardComp.vue?vue&type=script&lang=js"

import "./cardComp.vue?vue&type=style&index=0&id=76120e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76120e76"]])

export default __exports__